const googleMap = {
  inserted (el) {
    let element = el.childNodes[2]
    let value = element.getAttribute('marker')
    let disabled = element.getAttribute('disabled')
    var lt = 4.671810000000001
    var lg = -74.15522699999997
    if (value !== '') {
      lt = value.split('#')[0]
      lg = value.split('#')[1]
    }
    var myLatlng = new google.maps.LatLng(lt, lg)
    const options = {
      zoom: 17,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    }
    const map = new google.maps.Map(element, options)
    element.g_map = map
    let marker = new google.maps.Marker({
      map: map,
      title: 'ZF Bogota',
      position: myLatlng,
      draggable: !disabled
    })
    element.g_marker = marker
    let input = el.childNodes[0]
    let searchBox = new google.maps.places.SearchBox(input)
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)
    map.addListener('bounds_changed', function () {
      searchBox.setBounds(map.getBounds())
    })
    searchBox.addListener('places_changed', function () {
      marker.setMap(null)
      if (searchBox.getPlaces().length === 0) {
        return
      }
      let place = searchBox.getPlaces()[0]
      let bounds = new google.maps.LatLngBounds()
      if (!place.geometry) {
        console.log('Returned place contains no geometry')
        return
      }
      marker = new google.maps.Marker({
        map: map,
        title: place.name,
        position: place.geometry.location,
        draggable: !disabled
      })
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
      map.fitBounds(bounds)
      element.setAttribute('marker', marker.position.lat() + '#' + marker.position.lng())
      google.maps.event.addListener(marker, 'dragend', function (evt) {
        element.setAttribute('marker', marker.position.lat() + '#' + marker.position.lng())
      })
    })
    google.maps.event.addListener(marker, 'dragend', function (evt) {
      element.setAttribute('marker', marker.position.lat() + '#' + marker.position.lng())
    })
  }
}

export default googleMap



// WEBPACK FOOTER //
// app/javascript/src/vue/directives.js